$(document).ready(function () {

    //
    // Sprachumschalter ausblenden, wenn nur 1 Sprache vorhanden
    //
    let numItems = $('.c-language-switch__item').length;
    let numHidden = $('.c-language-switch__item--hidden').length;
    console.log(numItems, numHidden);
    if (numItems - numHidden === 1) {
        $('#language-switch').hide();
    }
    // /Sprachumschalter ausblenden

});


